// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const CSVDataDistillerAPI = {
    GetLocationCSVSources(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/locations/${req["locationId"]}/sources?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetCSVSmartMapping(fn, req) {
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/smart-mapping`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCSVSourceMapping(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/locations/${req["locationId"]}/sources/${req["sourceId"]}/mapping?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetCSVSourceUploadHistory(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/locations/${req["locationId"]}/sources/${req["sourceId"]}/upload-history?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetLocationCSVUploadHistory(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/locations/${req["locationId"]}/upload-history?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    DeleteCSVSourcePersons(fn, req) {
        return fn(`/syncapp/csv-data-distiller/v1/csv-source/delete-persons`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
